// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"d1ad239a8d990ceeffa6","883":"1100cbf9df22682cd8a1"}[chunkId] + ".js";
};